<div class="row m-0">
    <div class="col-5 px-2">
        <dp-filter-card [filterCard]="cpuFilterCard" [noResultsVisible]="cpuResult.length === 0"
            [showLoading]="showLoadingCpu" [subtitle]="cpuFilterCard.subtitle">
            @if (lineChartCpu) {
                <dp-chart ngProjectAs="body" [chart]="lineChartCpu"></dp-chart>
            }
        </dp-filter-card>
    </div>
    <div class="col-5 px-2">
        <dp-filter-card [filterCard]="ramFilterCard" [noResultsVisible]="ram.length === 0"
            [showLoading]="showLoadingRam" [subtitle]="ramFilterCard.subtitle" (filterChanged)="loadRamFilter($event)">
            @if (lineChartRam) {
                <dp-chart ngProjectAs="body" [chart]="lineChartRam"></dp-chart>
            }
        </dp-filter-card>
    </div>
    <div class="col-2 pe-0 ps-2">
        <dp-filter-card [filterCard]="diskFilterCard" [noResultsVisible]="disk.length === 0"
            [showLoading]="showLoadingDisk" [subtitle]="diskFilterCard.subtitle">
            @if (pieChart) {
                <dp-chart ngProjectAs="body" [chart]="pieChart"></dp-chart>
            }
        </dp-filter-card>
    </div>
</div>
